import { questionService } from "../services";

// state
const state = {
  items: [],
  item: {},
  loading: true,
};

// ACTIONS
const actions = {
  // get all questions
  GET_QUESTION_LIST({ commit }, options) {
    // trigger mutation -> loading = true
    commit("requestSent");
    options = options || {};
    return new Promise((resolve, reject) => {
      questionService.getList(options).then(
        (questions) => {
          commit("fetchItemsSuccess", questions);
          resolve(questions);
        },
        (error) => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },

  // create new question
  CREATE_QUESTION({ commit }, options) {
    commit("requestSent");
    options = options || {};
    return new Promise((resolve, reject) => {
      questionService.createQuestion(options).then(
        (question) => {
          commit("fetchItemSuccess", question);
          resolve(question);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  // add item to items
  ADD_ITEM({ commit }, item) {
    if (item) commit("addItem", item);
  },

  // remove item to items
  REMOVE_ITEM({ commit }, id) {
    commit("removeItem", id);
  },
};

// MUTATIONS
const mutations = {
  // http request fails
  requestFail(state) {
    state.loading = false;
    state.item = {};
    state.items = [];
  },
  // http request sent
  requestSent(state) {
    state.loading = true;
  },

  // model
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },
  // collection
  fetchItemsSuccess(state, items) {
    state.loading = false;
    state.items = items;
  },

  // add question to questions
  addItem(state, item) {
    state.items.push(item);
  },

  // remove question to questions
  removeItem(state, id) {
    const index = state.items.findIndex((question) => question.id == id);
    state.items.splice(index, 1);
  },
};

// GETTERS
const getters = {
  isLoading: (state) => state.loading,
};

// EXPORT
export const question = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
